import { Helmet } from "react-helmet-async";
import he from "he";

const MetaTags = ({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType,
  ogTitle,
  ogDescription,
  ogUrl,
  ogImage,
  schema,
}) => {
  const defaultTitle = "Efficient Inspection Management Solutions | TQCert";
  const defaultDescription =
    "Inspection Management - Streamline your processes with TQCert's inspection management solutions. Enhance efficiency, accuracy, and compliance with our trusted inspection services.";
  const defaultKeywords =
    "inspection management, inspection management solution";
  return (
    <Helmet>
      <title>{title ? he.decode(title) : defaultTitle}</title>

      {description && (
        <meta
          name="description"
          content={description ? he.decode(description) : defaultDescription}
        />
      )}

      {keywords && (
        <meta
          name="keywords"
          content={keywords ? he.decode(keywords) : defaultKeywords}
        />
      )}

      {canonicalUrl && <link rel="canonical" href={he.decode(canonicalUrl)} />}

      {ogTitle && <meta property="og:title" content={he.decode(ogTitle)} />}

      {ogType && <meta property="og:type" content={ogType} />}

      {ogDescription && (
        <meta property="og:description" content={he.decode(ogDescription)} />
      )}

      {ogUrl && <meta property="og:url" content={he.decode(ogUrl)} />}

      {ogImage && <meta property="og:image" content={ogImage} />}

      {schema && <script type="application/ld+json">{schema}</script>}
    </Helmet>
  );
};

export default MetaTags;
